// import performRequest from "../../api/request";
import performRequest from "../../api/request";
// import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";

const initialState = {
    totalTask: 0,
    totalCompleteTask: 0,
  };
  
  const SET_TASK_COUNTS = "SET_TASK_COUNTS";
  
  export const setTaskCounts = (data) => ({
    type: SET_TASK_COUNTS,
    payload: data,
  });
  
  export const fetchTaskCounts = () => async (dispatch) => {
    try {
      const res = await performRequest(
        "GET",
        `/tasks/getTaskManagementDashboard`
      );
  
      if (res.status === 200) {
        dispatch(
          setTaskCounts({
            totalTask: res?.data?.taskManagementCount,
            totalCompleteTask: res?.data?.completedTaskCount,
          })
        );
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
  };
  
  const taskReducer = (state = initialState, action) => {
    switch (action.type) {
      case SET_TASK_COUNTS:
        return {
          ...state,
          totalTask: action.payload.totalTask,
          totalCompleteTask: action.payload.totalCompleteTask,
        };
      default:
        return state;
    }
  };
  
  export default taskReducer;